import PageBanner from "@/components/feature/PageBanner";
import EmptyState from "@/components/base/EmptyState";
import { SkeletonCard } from "@/components/base/Skeleton";
import { useApi } from "@/hooks/useApi";
import type { GameItem } from "@/lib/types";
import GamesGrid from "./components/GamesGrid";
import HonorRoll from "./components/HonorRoll";
import { visibleGames } from "./utils";

// /games — 심심풀이 게임 카드 + 명예의 전당.
// 게임 로직은 서버가 서비스하므로 여기서는 «카드를 깔고 링크를 거는 것»만 한다.
export default function GamesPage() {
  const { data, loading, error, reload } = useApi<GameItem[]>("games.php");
  const games = visibleGames(data ?? []);

  return (
    <>
      <PageBanner
        title="심심풀이 게임"
        description="짬날 때 한 판. 명예의 전당에 이름을 올려보세요."
        breadcrumb={[{ label: "게임" }]}
      />

      <section className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-12">
        <h2 className="mb-5 flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
          <span aria-hidden="true">🎮</span>
          게임
        </h2>

        {loading ? (
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-6">
            {Array.from({ length: 6 }).map((_, i) => (
              <SkeletonCard key={i} />
            ))}
          </div>
        ) : error ? (
          <EmptyState
            icon="ri-error-warning-line"
            title="게임 목록을 불러오지 못했습니다"
            description={error}
            action={
              <button
                type="button"
                onClick={reload}
                className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600"
              >
                다시 시도
              </button>
            }
          />
        ) : (
          <GamesGrid games={games} />
        )}

        {!loading && !error && games.length > 0 && (
          <div className="mt-14">
            <HonorRoll games={games} />
          </div>
        )}
      </section>
    </>
  );
}